
<div class="collapse-item">
  <template v-if="handler.mode === 'flat'">
    <field-item
        v-if="handler.allowApiEndpointSelection"
        :disabled="handler.isDisabled({endPoint: apiEndPointDataSection.endPoint, apiMessageType: apiEndPointDataSection.apiMessageType}, apiEndPointContext)"
        @click="select(apiEndPointDataSection.select(endPoint, completePathForEndpoint))"
    >
      <row>
        <prefix>
          <icon glyph="api"/>
        </prefix>
        <column>
          {{ apiEndPointDataSection.endPoint.name }}
        </column>
      </row>
    </field-item>

    <collapsible-section
      class="collapse-item"
      :id="`dynamicInputsCollapse-${endPoint.client_id}-${level}-${dropdownControlId}`"
      control-name="apiEndPointCollapse"
      :is-open="false"
    >
      <template #section-header>
        {{ handler.header }}
      </template>
      <template #section-contents>
        <template v-if="modeIs('select')">
          <field-item
            v-for="prop in handler.dynamicInputsSection(lowerQ, endPoint, apiMessageType).properties"
            :key="prop.clientIdOrId"
            :disabled="handler.isDisabled(prop, computedChildTreeContext)"
            @click="select(handler.dynamicInputsSection(lowerQ, endPoint, apiMessageType).select(prop, endPoint, apiMessageType, completePathFor(prop)))"
          >
            <row>
              <prefix>
                <icon :glyph="dynamicInputGlyph(prop)"/>
              </prefix>
              <column>
                {{prop.name}}
              </column>
            </row>
          </field-item>

          <collapsible-section
            v-for="prop in handler.dynamicInputsSection(lowerQ, endPoint, apiMessageType).objects"
            class="collapse-item"
            :id="`dynamicInputsCollapse-${handler.variable.id}-${prop.id}`"
            control-name="apiEndPointObjectCollapse"
            :is-open="false"
            :key="prop.clientIdOrId"
          >
            <template #section-header>
              {{ prop.name }}
            </template>

            <template #section-contents>
              <api-object-data
                :handler="handler"
                :end-point="endPoint"
                :apiMessageType="apiMessageType"
                :object-dynamic-input="prop"
                :path="completePathFor(prop)"
                :q="lowerQ"
                @select="select"
                :parent-tree-context="computedChildTreeContext"
              />
            </template>
          </collapsible-section>
        </template>
      </template>
    </collapsible-section>
    <collapsible-section
      class="collapse-item"
      :id="`dynamicInputsCollapseURLParameters-${endPoint.client_id}-${level}-${dropdownControlId}`"
      control-name="apiEndPointCollapseURLParameters"
      :is-open="false"
    >
      <template #section-header>
        URL Parameters
      </template>
      <template #section-contents>
        <template v-if="modeIs('select')">
          <field-item
            v-for="prop in handler.URLParametersSection(lowerQ, endPoint).URLParameters"
            :key="prop.clientIdOrId"
            :disabled="handler.isDisabled(prop, computedChildTreeContext)"
            @click="select(handler.URLParametersSection(lowerQ, endPoint).select(prop, endPoint, completePathForURLParameter(prop)))"
          >
            <row>
              <prefix>
                <icon glyph="text"/>
              </prefix>
              <column>
                {{prop.name}}
              </column>
            </row>
          </field-item>
        </template>
      </template>
    </collapsible-section>
  </template>
</div>
